import { useEffect, useState } from "react";

export function useProfileListSearch({ enabled, customerId }) {
  const [query, setQuery] = useState("");
  const [expanded, setExpanded] = useState(false);
  useEffect(() => { setQuery(""); setExpanded(false); }, [enabled, customerId]);
  return { query, setQuery, expanded, expand: () => setExpanded(true), blur: () => { if (!query.trim()) setExpanded(false); } };
}
